import ExportSelectedRows from "../../ExportCSV";
import CommonGrid from "../CommonGrid/CommonGrid";
import {
  getFullkitGridColumns,
  fullkitGridFilters,
  fullkitGridGlobalFilterFields,
} from "./gridConfig";
import "./ModuleGrids.scss";

// baCell is now included in getFullkitGridColumns

const FullkitGrid = ({
  data = [],
  mode = "min",
  dataKey = "Project_ID",
  emptyMessage = "No fullkit data found.",
  tableProps = {},
  rows = 20,
  paginator,
  pageName = "fullkit",
  title = ""
}) => {
  // Use shared columns definition
  const columns = getFullkitGridColumns(mode);

  // Use shared filters/globalFilterFields
  const maximizedFilters = fullkitGridFilters;
  const maximizedGlobalFilterFields = fullkitGridGlobalFilterFields;

  return (
    <>
      {mode === "max" && (
        <div className="task-grid-filters my-3">
          <ExportSelectedRows
            allData={data}
            selectedRows={[]}
            headers={columns?.map(col => col?.field)}
            filename={`${title}_Records`}
          />
        </div>
      )}
      <CommonGrid
        data={data}
        columns={columns}
        mode={mode}
        filters={mode === "max" ? maximizedFilters : undefined}
        globalFilterFields={mode === "max" ? maximizedGlobalFilterFields : undefined}
        dataKey={dataKey}
        emptyMessage={emptyMessage}
        rows={rows}
        paginator={mode === "max" ? paginator : undefined}
        tableProps={tableProps}
        pageName={pageName}
        showACPFilter={true}
      />
    </>
  );
};

export default FullkitGrid;
